"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProperty = void 0;
var lodash_1 = __importDefault(require("lodash"));
/**
 * This function uses type predicates to allow typescript to
 * automatically narrow types based on whether an object has a property.
 *
 * Example usage
 *
 * 	const dataConfig: MetricDataConfig | FieldsDataConfig = getConfig();
 * 	if (hasProperty(dataConfig, 'metrics')) {
 *  	// typescript will automatically infer that dataConfig is of MetricDataConfig type
 * 	}
 */
function hasProperty(obj, prop) {
    return lodash_1.default.has(obj, prop);
}
exports.hasProperty = hasProperty;
